import { jsx, jsxs } from "react/jsx-runtime";
import { iconRegistry } from "@pcln/horizon-icons";
import { forwardRef } from "react";
import { cleanProps, cn } from "../../utils/index.js";
import { getIconSize } from "../../variants/interactions/iconButtonVariants.utils.js";
import { CdnIcon } from "../CdnIcon/index.js";
import { HorizonIcon } from "../HorizonIcon/index.js";
import { iconButtonVariants } from "./IconButton.variants.js";
const IconButton_IconButton = /*#__PURE__*/ forwardRef(function({ onClick, fillNone = false, className, iconName, title, slots = {
    buttonSlot: '',
    wrapperSlot: '',
    iconSlot: '',
    tapSpaceSlot: ''
}, buttonClassName, ...props }, ref) {
    const { buttonSlot, wrapperSlot, iconSlot, tapSpaceSlot } = iconButtonVariants({
        ...props,
        fillNone
    });
    const wrapperClasses = cn(wrapperSlot(), className, slots.wrapperSlot);
    const iconSlotClasses = cn(iconSlot(), slots.iconSlot);
    const buttonClasses = cn(buttonSlot(), buttonClassName, slots.buttonSlot);
    const tapSpaceClasses = cn(tapSpaceSlot(), slots.tapSpaceSlot);
    const iconSize = getIconSize(props.size);
    const isIconName = (name)=>'string' == typeof name && Object.hasOwn(iconRegistry, name);
    return /*#__PURE__*/ jsxs("button", {
        type: "button",
        onClick: onClick,
        title: title ?? iconName,
        ...cleanProps(props, [
            'type',
            'shadow',
            'active'
        ]),
        className: buttonClasses,
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("div", {
                className: tapSpaceClasses
            }),
            /*#__PURE__*/ jsx("div", {
                className: wrapperClasses,
                "data-testid": "icon-button-wrapper",
                children: isIconName(iconName) ? /*#__PURE__*/ jsx(HorizonIcon, {
                    className: iconSlotClasses,
                    name: iconName,
                    size: iconSize
                }) : /*#__PURE__*/ jsx(CdnIcon, {
                    className: iconSlotClasses,
                    iconName: iconName,
                    size: iconSize
                })
            })
        ]
    });
});
IconButton_IconButton.displayName = 'IconButton';
export { IconButton_IconButton as IconButton };
